<template>
  <div class="acao-social-content">
    <h1 class="title">AÇÃO SOCIAL</h1>
    <div class="section">
      <p class="text">
        Fundado em 2003 na cidade de Cataguases, o Projeto Social Bairro Pouso
        Alegre é uma organização sem fins lucrativo, que visa levar para cada
        criança e jovem assistido a oportunidade de desenvolver suas
        habilidades.
      </p>
      <p class="text">
        O projeto é composto por oito voluntários que atuam em áreas e setores
        diferenciados, atua em uma sede no Bairro Pouso Alegre e atende
        aproximadamente 100 crianças.
      </p>
      <img src="../assets/Pessoas.jpg" alt="Imagem Pessoas" class="picture" />
    </div>
  </div>
</template>

<script>
export default {
  name: "AcaoSocial",
};
</script>

<style scoped>
.acao-social-content {
  background-image: url("../assets/BackgroundAcaoSocial.jpg");
  background-size: cover;
  background-repeat: no-repeat;
  min-height: 100%;
  max-width: 100%;
}

.title {
  color: #f5f5f5;
  font-family: "Montserrat", sans-serif;
  font-size: 3em;
  font-weight: 300;
  text-align: center;
  padding: 4vh 0 0 0;
}

.title::after {
  content: "";
  display: block;
  width: 2.3em;
  height: 0.09em;
  background-color: #ffc737;
  opacity: 0.8;
  border-radius: 30px;
  margin: 0.1em 0 0 0;
  position: relative;
  left: 50%;
  top: 0;
  bottom: 0;
  transform: translateX(-50%);
}

.section {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  text-align: center;
  margin: 1em 1.25em 0 45%;
  padding: 0 0 3.5em 0;
}

.picture {
  border-radius: 2px;
  box-shadow: 4px 4px 6px #00000099;
  max-width: 572px;
  width: 100%;
  height: auto;
  text-align: center;
  margin-top: 3em;
}

.text {
  color: #f5f5f5;
  font-family: "Montserrat", sans-serif;
  font-size: 1.6em;
  font-weight: 400;
  width: 70%;
  line-height: 1.3em;
  text-align: center;
  margin: 1em 0 1em 0;
  text-shadow: 1px 1px 2px #000000cc;
}

@media only screen and (max-width: 992px) {
  .section {
    margin: 1em 0 0 0;
  }

  .picture {
    width: 45%;
    min-width: 320px;
  }

  .text {
    font-size: 1.2em;
    min-width: 340px
  }
}
</style>